<template>
  <li class="c-entrepreneur-video-decorative-item" :class="`c-entrepreneur-video-decorative-item--${icon.className}`">
    <icon class="c-entrepreneur-video-decorative-item__icon " :icon="icon.iconName" />
  </li>
</template>

<script>
import Icon from "objects/Icon";
export default {
  components: {
    Icon
  },
  props: {
    icon: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.c-entrepreneur-video-decorative-item {
  display: flex;

  z-index: 2;
  max-width: 50px;
  max-height: 50px;
  width: 100%;
  height: 100%;
  @media #{$breakpoint-horizontal} {
    position: absolute;
  }
  &--top {
    display: none;
    top: -50px;
    right: -50px;
    @media #{$breakpoint-horizontal} {
      display: flex;
    }
  }
  &--bottom {
    display: none;
    bottom: -50px;
    left: -50px;
    @media #{$breakpoint-horizontal} {
      display: flex;
    }
  }
  &--mobile {
    display: flex;

    @media #{$breakpoint-horizontal} {
      display: none;
    }
  }
  &__icon {
    &::v-deep svg {
      width: 100%;
      height: 100%;
    }
    .c-entrepreneur-video-decorative-item--top & {
      @include rotate(180deg);
    }
  }
}
</style>
